import { api } from '../../lib/api-client';

export type EducationItem = {
  /** `CandidateEducation.PublicKey` Guid. */
  id: string;
  degree: string;
  institution: string;
  /** Field of study (e.g. "Machine Learning"); null if not specified. */
  field: string | null;
  /** ISO datetime. */
  startDate: string;
  /** ISO datetime, o null cuando el programa está en curso. */
  endDate: string | null;
  /** Honors / thesis / notes adicionales; null si no se cargó. */
  description: string | null;
};

export type EducationResponse = {
  items: EducationItem[];
};

export type GetTalentEducationParams = {
  shortlistPublicKey: string;
  talentPublicKey: string;
};

export async function getTalentEducation(
  params: GetTalentEducationParams,
): Promise<EducationResponse> {
  const url =
    `/api/client/shortlists/${params.shortlistPublicKey}` +
    `/talents/${params.talentPublicKey}/education`;
  return api.get<EducationResponse>(url);
}
